import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

import { useTranslation } from 'react-i18next';

import { Box, Drawer, useTheme, Typography } from '@mui/material';

import BackArrowIcon from '../../../icons/BackArrowIcon';
import BackIcon from '../../../icons/BackIcon';
import Main from '../../../styled/Main';
import DrawerHeader from '../../../styled/DrawerHeader';
import ScannedProjectLeftSidePanel from './ScannedProjectLeftSidePanel';
import { useSelector } from 'react-redux';

import store from '../../../../store';
import { setSideBarIsOpened } from "../../../../store/actions/Project";

function ScannedProjectContainer()
{
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();

    const selectedProject = useSelector((state) => state.scannedProject.selectedProject);
    const open = useSelector((state) => state.project.sideBarIsOpened);

    const [drawerWidth, setDrawerWidth] = useState(500);

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            <Helmet>
                <title>{t('easyBoardOnline')}</title>
            </Helmet>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        padding: '20px'
                    },
                    padding: '0px',
                    borderLeft: '1px solid'+theme.palette.storeDrawer.borderLeft.color
                }}
                variant="persistent"
                anchor="left"
                open={open}
                PaperProps={{ sx: { position: "relative", padding: '0px', backgroundColor: theme.palette.dashboardLeftSidebar.background }}}
            >
                <DrawerHeader>
                    <button
                        type="button"
                        onClick={() => { navigate('../scanned-project'); }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            padding: '0px',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <BackArrowIcon />
                        <span style={{ color: '#638CA3' }}>{t('Back')}</span>
                    </button>
                    <Typography>{selectedProject?.name}</Typography>
                    <button
                        type="button"
                        onClick={() => { store.dispatch(setSideBarIsOpened(open ? false : true)); }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            padding: '0px',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <BackIcon />
                    </button>
                </DrawerHeader>
                <ScannedProjectLeftSidePanel />
            </Drawer>
            <Main open={open} drawerWidth={drawerWidth}>
                <Outlet />
            </Main>
        </Box>
    )
}

export default ScannedProjectContainer;